import { SB } from '@play-co/replicant';

export const racesSchema = {
  races: SB.map(
    SB.array(
      SB.object({
        id: SB.string(),
        score: SB.int(),
        createdAt: SB.int(),
        modifiedAt: SB.int(),
        claimedRewardAt: SB.int().optional(),
        bots: SB.array(
          SB.object({
            score: SB.int(),
            modifiedAt: SB.int(),
            createdAt: SB.int(),
          }),
        ).optional(),
      }),
    ),
  ),
  pendingRaceScore: SB.object({
    score: SB.int(),
    raceId: SB.string(),
    raceIndex: SB.int(),
  }).optional(),

  lastViewedRaceScore: SB.object({
    score: SB.int(),
    raceId: SB.string(),
    raceIndex: SB.int(),
    timestamp: SB.int(),
    autoShowed: SB.boolean().optional(),
  }).optional(),

  // When race get into online bot update mode
  raceOnlineAt: SB.number().default(0),

  // Last time when online bots were updated
  raceBotUpdateAt: SB.number().default(0),

  // When race get into offline, from this time we do not update bots with online logic
  raceOfflineAt: SB.number().default(0),
};

export type RaceState = SB.ExtractType<
  (typeof racesSchema)['races']
>[string][number];

export type BotState = Exclude<
  SB.ExtractType<(typeof racesSchema)['races']>[string][number]['bots'],
  undefined
>[number];
